const LABELS: Record<string, string> = {
  react: 'React',
  nextjs: 'Next.js',
  preact: 'Preact',
  astro: 'Astro',
  qwik: 'Qwik',
  solidjs: 'SolidJS',
  svelte: 'Svelte',
  webassembly: 'WebAssembly',
  vanillajs: 'Vanilla JS',
  angular: 'Angular',
  vue: 'Vue',
  javascript: 'JavaScript',
  typescript: 'TypeScript',
  ts: 'TypeScript',
  csharp: 'C#',
  cs: 'C#',
  dotnet: '.NET',
  fsharp: 'F#',
  fs: 'F#',
  python: 'Python',
  py: 'Python',
  go: 'Go',
  java: 'Java',
  php: 'PHP',
  ruby: 'Ruby',
  rb: 'Ruby',
  kotlin: 'Kotlin',
  groovy: 'Groovy',
  swift: 'Swift',
  rust: 'Rust',
  cpp: 'C++',
  c: 'C',
  default: 'Default',
}

export function formatQuickStartLanguageLabel(languageKey: string): string {
  const lower = languageKey.toLowerCase()
  return LABELS[lower] ?? languageKey.charAt(0).toUpperCase() + languageKey.slice(1)
}
